<template>
  <div>
    <!-- Page Title and Back Button -->
    <div class="task-details-header row mb-4 py-3 align-items-center shadow-sm rounded">
      <div class="col-md-6 d-flex align-items-center">
        <h1 class="my-0">
          <i class="fas fa-tasks me-2 text-primary"></i> Task Details
        </h1>
      </div>
      <div class="col-md-6 text-end">
        <button @click="goBack" class="btn btn-back btn-lg">
          <i class="fas fa-arrow-left me-2"></i> Back
        </button>
      </div>
    </div>

    <!-- Task Details Card -->
    <div v-if="taskDetails" class="card mx-auto p-4 shadow-lg" style="max-width: 1300px;">
      <div class="card-body">
        <h5 class="card-title mb-4">{{ taskDetails.title }}</h5>
        <ul class="list-unstyled">
          <li class="mb-3 d-flex align-items-center">
            <i class="fas fa-id-badge me-2 text-secondary"></i>
            <strong>ID:</strong> {{ taskDetails.id }}
          </li>
          <li class="mb-3 d-flex align-items-center">
            <i class="fas fa-project-diagram me-2 text-secondary"></i>
            <strong>Project:</strong> {{ taskDetails.projectName || 'N/A' }}
          </li>
          <li class="mb-3 d-flex align-items-center">
            <i class="fas fa-user me-2 text-secondary"></i>
            <strong>Assigned to:</strong> {{ taskDetails.assignedto }}
          </li>
          <li class="mb-3 d-flex align-items-center">
            <i class="fas fa-calendar-alt me-2 text-secondary"></i>
            <strong>Start Date:</strong> {{ taskDetails.startDate }}
          </li>
          <li class="mb-3 d-flex align-items-center">
            <i class="fas fa-calendar-check me-2 text-secondary"></i>
            <strong>End Date:</strong> {{ taskDetails.endDate }}
          </li>
          <li class="mb-3 d-flex align-items-center">
            <i class="fas fa-info-circle me-2 text-secondary"></i>
            <strong>Status:</strong>
            <span
              :class="{
                'bg-success text-white px-2 py-1 rounded': taskDetails.status === 'Open',
                'bg-danger text-white px-2 py-1 rounded': taskDetails.status === 'Closed',
                'bg-warning text-dark px-2 py-1 rounded': taskDetails.status === 'Inprogress'
              }"
              style="display: inline-block;"
            >
              {{ taskDetails.status }}
            </span>
          </li>
          <li class="mb-3 d-flex align-items-center">
            <i class="fas fa-user-edit me-2 text-secondary"></i>
            <strong>Created by:</strong> {{ taskDetails.created_by }}
          </li>
        </ul>
      </div>
    </div>
    <!-- Responsive Description Section -->
    <div v-if="taskDetails" class="description-container mx-auto mt-4 p-4 shadow-sm" style="max-width: 1300px;">
      <h5 class="mb-3">
        <i class="fas fa-align-left me-2 text-secondary"></i> Description
      </h5>
      <div class="table-responsive">
        <p class="description-text" v-html="taskDetails.description"></p>
      </div>
    </div>

    <div v-else class="text-center mt-5">
      <p>No task details available.</p>
    </div>

    <div class="row">
      <div class="col">
        <button @click="goBack" class="btn btn-primary btn-lg mt-3">Back</button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  name: 'TaskDetailPage',
  setup() {
    const store = useStore();
    const router = useRouter();
    const taskDetails = computed(() => store.state.taskDetails);

    const goBack = () => {
      router.push({ name: 'TaskPage' });
    };

    return {
      taskDetails,
      goBack,
    };
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
  background-color: #f8f9fa;
}

.description-container {
  border-radius: 10px;
  background-color: #ffffff;
  border-left: 4px solid #007bff;
  overflow-wrap: break-word;
}

.table-responsive {
  overflow-x: auto;
}

.description-text {
  font-size: 1rem;
  line-height: 1.5;
  word-break: break-word;
}

/* List styling */
.list-unstyled li {
  font-size: 1.1rem;
}

.list-unstyled strong {
  margin-right: 0.5rem;
}
</style>
